module.exports = __webpack_public_path__ + "img/setUpCards_6.b99301ec.jpg";